
<!-- DeliverySlotModal.svelte -->
<script>
  import { createEventDispatcher } from 'svelte';

  export let isOpen = false;
  export let deliverySlots = [];
  export let isLoading = false;

  let errorMessage = null;
  const dispatch = createEventDispatcher();

  function handleClose() {
    dispatch('close');
  }

  function handleSelect(slotId) {
    if (deliverySlots.length > 0) {
      dispatch('select', slotId);
    } else {
      // You might want to display a more user-friendly message here
      errorMessage = "No delivery slots available for this pickup point.";
    }
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function formatTime(timeString) {
    const [hour, minute] = timeString.split(':');
    const formattedHour = (parseInt(hour, 10) % 12) || 12;
    const ampm = parseInt(hour, 10) >= 12 ? 'PM' : 'AM';
    return `${formattedHour}:${minute} ${ampm}`;
  }
</script>

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-width: 80%;
  }

  .modal-content h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .modal-content ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .modal-content li {
    margin-bottom: 10px;
  }

  .error-message {
    color: red;
    margin-top: 10px;
  }
  
  .modal-content button {
    background-color: #1976d2;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .modal-content button:hover {
    background-color: #1565c0;
  }

  .close-button {
    background-color: #ddd;
    color: #333;
  }

  .close-button:hover {
    background-color: #bbb;
  }
</style>

{#if isOpen}
  <div class="modal-overlay" on:click={handleClose}>
    <div class="modal-content" on:click|stopPropagation>
      <h2>Select Delivery Slot</h2>

      {#if isLoading}
        <div class="dot-loader"> <!-- Use the same dot loader as the other modal -->
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      {:else if deliverySlots.length === 0}
        <p>{errorMessage || "No delivery slots available"}</p> <!-- Display error message if any -->
      {:else}
        <ul>
          {#each deliverySlots as slot}
            <li>
              <button on:click={() => handleSelect(slot.delivery_slot_id)}>
                {slot.day} - {formatTime(slot.delivery_slot_delivery_time)}
              </button>
            </li>
          {/each}
        </ul>
      {/if}

      <button class="close-button" on:click={handleClose}>Close</button>
    </div>
  </div>
{/if}
